import { Box } from '@mui/material';
import React from 'react';
import { AdminDataTable } from '../../components';
import { getJobOpeningColumns } from '../../functions';
import { useJobOpeningTab } from '../../hooks';
import type { IJobOpeningRow, IJobOpeningTabProps } from '../../interfaces';

export const JobOpeningTab = ({ searchTerm }: IJobOpeningTabProps) => {
  const {
    jobOpeningData,
    onPageChange,
    pageNumber,
    totalPages,
    loading,
    totalRecords,
    handleRowClick,
  } = useJobOpeningTab(searchTerm);

  const columns = getJobOpeningColumns(handleRowClick);

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      <AdminDataTable<IJobOpeningRow>
        columns={columns}
        rows={jobOpeningData}
        isLoading={loading}
        currentPage={pageNumber}
        totalPages={totalPages}
        totalRecords={totalRecords}
        rowsPerPage={5}
        onPageChange={onPageChange}
        onRowClick={handleRowClick}
        emptyTitle="No Job Openings"
        emptySubtitle="There are currently no job openings matching your criteria."
      />
    </Box>
  );
};
